import { createAsyncAction } from 'typesafe-actions'
import { FastTrackPersonDetails } from 'types/global'
import registrationApi from 'api/rest/registration'
import { withRegLogAsync } from 'modules/reg-logger'

export const FAST_TRACK_PERSON_DETAILS_REQUESTED =
  'fastTrackReg/FAST_TRACK_PERSON_DETAILS_REQUESTED'
export const FAST_TRACK_PERSON_DETAILS_COMPLETED =
  'fastTrackReg/FAST_TRACK_PERSON_DETAILS_COMPLETED'
export const FAST_TRACK_PERSON_DETAILS_FAILED = 'fastTrackReg/FAST_TRACK_PERSON_DETAILS_FAILED'

export const requestFastTrackPersonDetails = createAsyncAction(
  FAST_TRACK_PERSON_DETAILS_REQUESTED,
  FAST_TRACK_PERSON_DETAILS_COMPLETED,
  FAST_TRACK_PERSON_DETAILS_FAILED
)<void, FastTrackPersonDetails, Error>()

export const getFastTrackPersonDetails = (regToken: string) => {
  return async dispatch => {
    const getBasicPersonDetails = withRegLogAsync(
      registrationApi.getBasicPersonDetails.bind(registrationApi),
      'getBasicPersonDetails'
    )
    try {
      dispatch(requestFastTrackPersonDetails.request())
      dispatch(requestFastTrackPersonDetails.success(await getBasicPersonDetails(regToken)))
    } catch (e) {
      console.warn('Failed to get Person details: ', e && (e as Error)?.message)
      dispatch(requestFastTrackPersonDetails.failure(e as Error))
    }
  }
}
